import { Col } from "react-bootstrap";
import stacktrek from "../assets/logo/stacktrek.png";
import collabera from "../assets/logo/collabera.png";
import core from "../assets/logo/core.png";
import metrobank from "../assets/logo/metrobank.png";

const Companies = () => {
  return (
    <Col className="companies" lg={12}>
      <h2>Companies</h2>
      <p>I'm proud to have collaborated with some awesome companies:</p>
      <div className="companies-bx">
        {companies.map((company) => {
          return (
            <img
              key={company.name}
              className="company"
              src={company.logo}
              alt={company.name}
            />
          );
        })}
      </div>
    </Col>
  );
};

const companies = [
  { name: "StackTrek", logo: stacktrek },
  { name: "Core", logo: core },
  { name: "Collabera", logo: collabera },
  { name: "Metrobank", logo: metrobank },
];

export default Companies;
